module.exports = __webpack_public_path__ + "static/media/USDC-logo.381a07e5.png";